export default "__VITE_ASSET__4278531c__"